module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/mattdavies/Development/Sites/lof/web/app/themes/landscapes/node_modules/axios/index.js
// module id = 30
// module chunks = 0